/**
 * AttendanceReports — master tab inside Reports Hub. Today it hosts the
 * AdminReportsPage (which has all 5 attendance sub-tabs); designed so future
 * report categories (Tasks/Finance/Client) become sibling master tabs.
 */
import React from 'react';
import AdminReportsPage from '../AdminReportsPage';

const AttendanceReports = () => <AdminReportsPage />;
export default AttendanceReports;
